module.exports = __webpack_public_path__ + "static/media/profile.67748782.jpg";